import React from "react";
import Effect from "./index";
import UnconfiguredComponent from "../common3/UnconfiguredComponent";
import HiddenComponent from "../common3/HiddenComponent";

import isEmpty from "lodash/isEmpty";

const EffectEdit = (props) => {
  const { extra = {}, builder = false } = props;
  const { options = null, optionsType } = extra;

  if (!extra.effects) {
    return <UnconfiguredComponent hint="Effect.AddEffect" />;
  }

  return (
    <HiddenComponent icon={"fad fa-database"} label="Effect" hint={props.id} />
  );
};

export default EffectEdit;
